<template>
  <section :class="['px-0!', backgroundClasses]">
    <div class="h-pad">
      <CTABlock
        :button="content.buttons?.length ? content.buttons[0] : null"
        :description="content.description"
        :subtitle="content.subtitle"
        :title="content.title"
      />
    </div>
    <div class="mt-10 lg:mt-15 overflow-hidden transition-all" v-reveal>
      <div class="animate-carousel flex gap-4 will-change-transform w-max">
        <ResponsiveImage
          v-for="(img, imgKey) in images"
          :media="img"
          class="w-57.5 lg:w-97.5 h-72.5 lg:h-125 object-cover odd:mt-5 transition-[width_height]"
          :key="`${content.flexKey}-image-${imgKey}`"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import CTABlock from '@/components/blocks/CTABlock.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'MosaicSection',
  components: { CTABlock, ResponsiveImage },
  props: {
    content: {
      type: Object as PropType<MosaicSection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
  computed: {
    images() {
      if (this.content.images.length) {
        return Array(4).fill(this.content.images).flat()
      }

      return []
    },
  },
}
</script>
